var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "海关批量核验",
        visible: _vm.visible,
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "手动指定核验结果" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.verifyResult,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "verifyResult", $$v)
                    },
                    expression: "form.verifyResult"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "未核验", value: "1" } }),
                  _c("el-option", {
                    attrs: { label: "已核验有效", value: "2" }
                  }),
                  _c("el-option", { attrs: { label: "编号无效", value: "3" } }),
                  _c("el-option", { attrs: { label: "过期", value: "4" } }),
                  _c("el-option", { attrs: { label: "额度不足", value: "5" } })
                ],
                1
              )
            ],
            1
          ),
          _c("el-form-item", [
            _c("span", { staticClass: "tip-text" }, [
              _vm._v("待处理选中条数：" + _vm._s(_vm.selectedCount))
            ])
          ])
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }